import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Compiler, Component, ComponentFactory, ComponentRef, ModuleWithComponentFactories, NgModule, OnInit, ViewChild,
  ViewContainerRef
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { SafeHtmlPipe } from 'src/app/pipe/safe.pipe';
import { LazyLoadScriptService } from '../../lazy_load_script_service';
import { PageService } from '../../services';
import { Meta, Title } from '@angular/platform-browser';

declare function OneHr();
@Component({
  selector: 'app-special_measures',
  templateUrl: './special_measures.component.html',
  styleUrls: ['./special_measures.component.scss']
})
export class special_measuresComponent implements OnInit {

  @ViewChild('container', { static: true, read: ViewContainerRef }) container: ViewContainerRef;

  private componentRef: ComponentRef<{}>;
  constructor(
    private service: PageService,
    public sanitizer: DomSanitizer,
    private compiler: Compiler,
    public cdRef: ChangeDetectorRef,
    private meta: Meta,
    private title: Title,
    private lazyLoadService: LazyLoadScriptService
  ) { 
    this.meta.addTags([
      {name: 'description', content: 'Special Measures page of UN - One HR - Salary Survey'},
      {name: 'author', content: 'One HR, Salary Survey'},
      {name: 'keyword', content: 'One HR, Salary Survey, Special Measures'}
    ]);
    this.setTitle('UN - Special Measures');
  }
  public setTitle(newTitle: string){
    this.title.setTitle(newTitle); 
  }
  slug = 'special_measures';


  template: string;
  list_items: string;
  data: any = {};
  public async ngOnInit() {
    try {
      this.service.get(this.slug).subscribe((response: any) => {
        var str = response.data.html?.map(ele => ele.html).join("");
        this.template = str;
        this.list_items = `
          <div class="section" *ngIf="totalItems > 0">
            <div class="container-fluid">
              <div class="col-md-12 p-5 mt-2 grey-border-bottom" style="padding: 5px !important;">
                <div class="d-flex flex-row-reverse" *ngIf="spm && spm.length > 0">
                  <div class="p-2 ">
                    <div ngbDropdown class="d-inline-block">
                      <label class="custom-lbl-bg">Records per page
                        <button class="btn tiny-select dropdown-toggle " style="font-size: 11px;padding: 8px 20px;"
                          ngbDropdownToggle>{{pageVars.itemPerPage}}</button>
                      </label>
                      <div ngbDropdownMenu class="rounded-0" aria-labelledby="Records Per Page">
                        <button ngbDropdownItem class="pt-1" style="font-size: 12px; padding: 4px;  margin: 0px;"
                          aria-label="Sort Jobs" id="5" (click)="pageVars.itemPerPage=5;fetchSPMs()">5</button>
                        <button ngbDropdownItem class="pt-1" style="font-size: 12px; padding: 4px;  margin: 0px;"
                          aria-label="Sort Jobs" id="10" (click)="pageVars.itemPerPage=10;fetchSPMs()">10</button>
                        <button ngbDropdownItem class="pt-1" style="font-size: 12px; padding: 4px;  margin: 0px;"
                          aria-label="Sort Jobs" id="20" (click)="pageVars.itemPerPage=20;fetchSPMs()">20</button>
                        <button ngbDropdownItem class="pt-1" style="font-size: 12px; padding: 4px;  margin: 0px;"
                          aria-label="Sort Jobs" id="50" (click)="pageVars.itemPerPage=50;fetchSPMs()">50</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            <!--  <div class="col-12 mt-2">
                <span class="pull-right" style="float: inline-end!important">
                  <div class="form-inline justify-content-end">
                    <div class="form-group d-flex" *ngIf=false>
                      <label style="font-size: 0.9em;">Sort By: &nbsp;</label>
                      <div ngbDropdown class="d-inline-block">
                        <button class="btn tiny-select dropdown-toggle" style="font-size: 11px;padding: 3px;"
                          ngbDropdownToggle>{{pageVars.sortByTitle}}</button>
                        <div ngbDropdownMenu class="rounded-0" aria-labelledby="Sort By">
                          <button ngbDropdownItem class="pt-1" aria-label="Sort Jobs" id="jt"
                            style="font-size: 12px; padding: 4px;  margin: 0px;"
                            (click)="sortSPMs('name', 1);pageVars.sortByTitle='Name Ascending'">Name
                            Ascending
                          </button>
                          <button ngbDropdownItem class="pt-1" aria-label="Sort Jobs" id="jt1"
                            style="font-size: 12px; padding: 4px;  margin: 0px;"
                            (click)="sortSPMs('name', -1);pageVars.sortByTitle='Name Descending'">Name
                            Descending
                          </button>
                          <button ngbDropdownItem class="pt-1" aria-label="Sort Jobs" id="sd"
                            style="font-size: 12px; padding: 4px;  margin: 0px;"
                            (click)="sortSPMs('expirationDate', 1);pageVars.sortByTitle='Expiration Ascending'">Expiration
                            Ascending
                          </button>
                          <button ngbDropdownItem class="pt-1" aria-label="Sort Jobs" id="sd1"
                            style="font-size: 12px; padding: 4px;  margin: 0px;"
                            (click)="sortSPMs('expirationDate', -1);pageVars.sortByTitle='Expiration Descending'">Expiration
                            Descending
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group d-flex ml-2" *ngIf=false>
                      <label style="font-size: 0.9em;">Records per Page: &nbsp;</label>
                      <div ngbDropdown class="d-inline-block">
                        <button class="btn tiny-select dropdown-toggle" style="font-size: 11px;padding: 3px;"
                          ngbDropdownToggle>{{pageVars.itemPerPage}}</button>
                        <div ngbDropdownMenu class="rounded-0" aria-labelledby="Records Per Page">
                          <button ngbDropdownItem class="pt-1" style="font-size: 12px; padding: 4px;  margin: 0px;"
                            aria-label="Sort Jobs" id="5" (click)="pageVars.itemPerPage=5;fetchSPMs()">5</button>
                          <button ngbDropdownItem class="pt-1" style="font-size: 12px; padding: 4px;  margin: 0px;"
                            aria-label="Sort Jobs" id="10" (click)="pageVars.itemPerPage=10;fetchSPMs()">10</button>
                          <button ngbDropdownItem class="pt-1" style="font-size: 12px; padding: 4px;  margin: 0px;"
                            aria-label="Sort Jobs" id="20" (click)="pageVars.itemPerPage=20;fetchSPMs()">20</button>
                          <button ngbDropdownItem class="pt-1" style="font-size: 12px; padding: 4px;  margin: 0px;"
                            aria-label="Sort Jobs" id="50" (click)="pageVars.itemPerPage=50;fetchSPMs()">50</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
              </div> -->
            </div>

            <div class="container-fluid pt-0 d-none d-sm-block">
              <div class="col-12 p-0 m-0">
                <table class="table table-survey">
                  <thead>
                    <tr>
                      <!-- <th scope="col">Name</th> -->
                      <th class="u-text-primary clickable col-md-2"
                        (click)="sortSPMs('dutyStation.name', -this.pageVars.sortDirection)">Duty Station <i
                          class="fas fa-sort"></i> </th>
                      <th class="u-text-primary col-md-7">Country</th>
                      <th class="u-text-primary col-md-7">Measure</th>
                      <th class="u-text-primary col-md-2 clickable"
                        (click)="sortSPMs('expiryDate', -this.pageVars.sortDirection)">Expiration Date <i class="fas fa-sort"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody *ngIf="spm && spm.length > 0">
                    <tr *ngFor="let s of spm">
                      <!-- <td>{{s.name}}</td> -->
                      <td>{{s.dutyStation.name}}</td>
                      <td>{{s.country.name}}</td>
                      <td>
                        <div [innerHTML]="s.description | safeHtml"></div>
                      </td>
                      <td>{{s.expiryDate}} </td>
                    </tr>
                  </tbody>
                  <tbody *ngIf="spm && spm.length == 0">
                    <tr>
                      <td colspan="3" class="text-center"> No records found</td>
                    </tr>
                  </tbody>
                </table>
                <pagination *ngIf="spm && spm.length > 0" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
                  lastText="&raquo;" [itemsPerPage]="pageVars.itemPerPage" class="justify-content-center"
                  [totalItems]="totalItems" [(ngModel)]="currentPage" (pageChanged)="pageChanged($event)">
                </pagination>
              </div>
            </div>

            <div class="container-fluid d-sm-none" *ngIf="spm">
              <div class="card shadow border-0 my-3" style="box-shadow: -0px 1px 3px 0px #aaaaaa;border-radius: 0;"
                *ngFor="let s of spm">
                <div class="card-header d-flex border-0 p-2" style="border-radius: 0;">
                  <span><b>Duty Station:</b> {{s.dutyStation.name}}</span>
                </div>
                <div class="card-body p-2">
                  <div class="mb-2"><b>Measures:</b></div>
                  <div [innerHTML]="s.description | safeHtml"></div>
                  <div class="d-flex p-0" style="font-size: 0.9em;">
                    <b>Expiration Date:</b><span> &nbsp; {{s.expiryDate}}</span>
                  </div>
                </div>
              </div>

              <pagination previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"
                [itemsPerPage]="pageVars.itemPerPage" class="justify-content-center" [totalItems]="totalItems"
                [(ngModel)]="currentPage" (pageChanged)="pageChanged($event)">
              </pagination>
            </div>
          </div>
        `;
        this.compileTemplate();
      });
    } catch (error) { }
  }


  compileTemplate() {
    let metadata = {
      selector: `runtime-component-sample`,
      template: this.template + this.list_items,
      changeDetection: ChangeDetectionStrategy.Default
    };

    let factory = this.createComponentFactorySync(this.compiler, metadata, null, this);

    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
    this.componentRef = this.container.createComponent(factory);
    this.lazyLoadService.loadScript('/assets/js/onehr.js').subscribe(_ => {

    });
  }

  private createComponentFactorySync(compiler: Compiler, metadata: Component, componentClass: any, THIS: any,):
    ComponentFactory<any> {
    const cmpClass = componentClass || class RuntimeComponent {
      spm: any;
      totalItems = 10;
      currentPage = 1;
      itemPerPage = 10;
      pageVars: any = { sortByTitle: 'Name Ascending', itemPerPage: 10, sortDirection: 1 };

      public ngOnInit() {
        this.fetchSPMs();
      }

      fetchSPMs() {
        THIS.service.getSpecialMeasuresList(this.currentPage - 1, this.pageVars.itemPerPage, this.pageVars.sortBy, this.pageVars.sortDirection).subscribe(res => {
          this.spm = res.data.result;
          this.totalItems = res.data.pageInfo[0].count;
        });
      }

      sortSPMs(attr, descending) {
        this.pageVars.sortBy = attr;
        this.pageVars.sortDirection = descending;
        this.fetchSPMs();
      }

      pageChanged(event) {
        // itemsPerPage: 2
        this.currentPage = event.page;
        // console.log(event);
        this.fetchSPMs();
      }

    };
    const decoratedCmp = Component(metadata)(cmpClass);

    const decoratedNgModule = NgModule({
      imports: [CommonModule, PaginationModule.forRoot(), NgbModule], declarations:
        [decoratedCmp, SafeHtmlPipe]
    })(cmpClass);

    const module: ModuleWithComponentFactories<any> = compiler.compileModuleAndAllComponentsSync(decoratedNgModule);
    return module.componentFactories.find(f => f.componentType === decoratedCmp);
  }
}